<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#clip0_1527_17375)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM5.50503 5.50503C5.77839 5.23166 6.22161 5.23166 6.49497 5.50503L8 7.01005L9.50502 5.50503C9.77839 5.23166 10.2216 5.23166 10.495 5.50503C10.7683 5.77839 10.7683 6.22161 10.495 6.49498L8.98995 8L10.495 9.50502C10.7683 9.77839 10.7683 10.2216 10.495 10.495C10.2216 10.7683 9.77839 10.7683 9.50502 10.495L8 8.98995L6.49497 10.495C6.22161 10.7683 5.77839 10.7683 5.50503 10.495C5.23166 10.2216 5.23166 9.77839 5.50503 9.50502L7.01005 8L5.50503 6.49497C5.23166 6.22161 5.23166 5.77839 5.50503 5.50503Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1527_17375">
        <rect
          width="16"
          height="16"
          fill="currentColor"
        />
      </clipPath>
    </defs>
  </svg>
</template>
